export default __webpack_public_path__ + "static/media/want_more.4d42a821.png";